/** Parse the legacy callback as data. Never execute returned JavaScript or HTML. */
export function parseImportResult(text, callback = 'finishUpload') {
  if (!['finishUpload', 'finishImport'].includes(callback)) return null
  const pattern = new RegExp(`${callback}\\(\\s*(true|false)\\s*,\\s*(['"])((?:\\\\[\\s\\S]|(?!\\2)[^\\\\])*)\\2\\s*\\)`, 'i')
  const match = pattern.exec(text ?? '')
  if (!match) return null
  let message
  if (match[2] === '"') {
    try { message = JSON.parse(`"${match[3]}"`) } catch { return null }
  } else {
    message = match[3].replace(/\\(u[0-9a-f]{4}|['"\\nrt])/gi, (_, value) => {
      if (value[0] === 'u') return String.fromCharCode(parseInt(value.slice(1), 16))
      return ({ n: '\n', r: '\r', t: '\t' })[value] ?? value
    })
  }
  message = message.replace(/<br\s*\/?>/gi, '\n').replace(/&(amp|lt|gt|quot|apos|#\d+|#x[0-9a-f]+);/gi, (entity, code) => {
    if (!code.startsWith('#')) return ({ amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" })[code.toLowerCase()] ?? entity
    const number = code[1].toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : Number(code.slice(1))
    return number >= 0 && number <= 0x10ffff ? String.fromCodePoint(number) : entity
  })
  return { ok: match[1].toLowerCase() === 'true', message: message.trim() }
}
